import { useCallback, useEffect, useState } from "react";

import { TrackingEventTypes, trackEvent } from "@is/services/EventTracking";

import { DELETE } from "../Passcode.constants";

type Props = {
  maskedPasscode: string[];
  onPasscodeViewClose: () => void;
};

const useManagePasscode = ({ maskedPasscode, onPasscodeViewClose }: Props) => {
  const [passcode, setPasscode] = useState<string[]>([]);
  const [isShaking, setIsShaking] = useState(false);

  const handleClick = useCallback((value: string) => {
    setPasscode((prev) => {
      if (value === DELETE) {
        return prev.slice(0, -1);
      }

      return [...prev, value];
    });
  }, []);

  useEffect(() => {
    if (
      !!passcode.length &&
      !!maskedPasscode.length &&
      passcode.length === maskedPasscode.length
    ) {
      if (passcode.join("") === maskedPasscode.join("")) {
        onPasscodeViewClose();

        trackEvent({
          eventType: TrackingEventTypes.ValidPasscodeEntered,
          data: {},
        });
      } else {
        setIsShaking(true);

        trackEvent({
          eventType: TrackingEventTypes.InvalidPasscodeEntered,
          data: {},
        });
      }

      setTimeout(() => {
        setIsShaking(false);
        setPasscode([]);
      }, 250);
    }
  }, [maskedPasscode, onPasscodeViewClose, passcode]);

  return {
    passcode,
    handleClick,
    isShaking,
  };
};

export default useManagePasscode;
